import useSWR from "swr"
import { DeliveryApi } from "../../../apis"
import { IDeliveryNotePlus } from "../../../models/DeliveryNote"

export interface UsePendingDeliveriesParams {
  channel?: string | null
  page?: number
  pageSize?: number
}

export interface PendingDeliveriesResponse {
  rows: IDeliveryNotePlus[]
  count: number
}

export function usePendingDeliveriesQuery({
  channel,
  page = 1,
  pageSize = 20,
}: UsePendingDeliveriesParams) {
  const cacheKey = ["pending-deliveries", channel ?? "ALL", page, pageSize] as const

  const swr = useSWR<PendingDeliveriesResponse>(
    cacheKey,
    async () => {
      // Spec §2.5 D3 — Хүлээлтэнд covers DNs that are not yet on a route:
      // DRAFT (not assigned) and ASSIGNED (assigned to staff but no route stop).
      // `excludeRouted` drops any DN that already has a delivery_route_stop row,
      // so once a DN is added to a route it disappears from here and shows only
      // inside its route / the active tab. Stats applies the same exclusion.
      const filter: Record<string, unknown> = {
        deliveryNoteStatus: ["DRAFT", "ASSIGNED"],
        excludeRouted: true,
      }
      if (channel) filter.deliveryChannel = channel
      const response = await DeliveryApi.list({
        filter,
        offset: { page, limit: pageSize },
        // Хүргэх өдрөөр өсөхөөр — ойрын хүргэлт дээр (BE: огноогүй нь сүүлд).
        order: ["deliveryDate", "ASC"],
      })
      // Backend returns {rows, count} via findAndCountAll
      return response as PendingDeliveriesResponse
    },
    { revalidateOnFocus: false, keepPreviousData: true },
  )

  return {
    data: swr.data,
    isLoading: swr.isLoading,
    error: swr.error,
    mutate: swr.mutate,
  }
}
